import { render, staticRenderFns } from "./PortalFooter.vue?vue&type=template&id=58ddfd20&scoped=true&"
import script from "./portalFooter.ts?vue&type=script&lang=ts&"
export * from "./portalFooter.ts?vue&type=script&lang=ts&"
import style0 from "./PortalFooter.vue?vue&type=style&index=0&id=58ddfd20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ddfd20",
  null
  
)

export default component.exports